import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, LayoutGrid, Calendar, Dice5, Gamepad2, Newspaper, User, ShoppingBag, Crown, Shield, LogOut, LogIn, BookOpen } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

const Row = ({ to, icon: Icon, label, gold, onClick, testId }) => (
  <Link
    to={to}
    onClick={onClick}
    className={`flex items-center gap-3 px-4 py-3.5 border-b border-white/5 font-overline text-xs transition-colors hover:bg-white/5 ${gold ? "text-[#D4AF37]" : "text-neutral-200"}`}
    data-testid={testId}
  >
    <Icon className="w-4 h-4" /> {label}
  </Link>
);

export const MobileMenu = ({ user, isSilverOrGold, onLogout }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setOpen(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="md:hidden p-2 hover:bg-white/5 transition-colors" aria-label="Apri menu" data-testid="mobile-menu-trigger">
          <Menu className="w-6 h-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[85vw] max-w-sm bg-[#0A0A0A] border-l border-[#D4AF37]/30 text-white p-0 overflow-y-auto" data-testid="mobile-menu">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <div className="px-4 pt-6 pb-4 border-b border-white/10">
          <div className="font-display font-black text-xl leading-none">POWER FITNESS<span className="text-[#D4AF37]"> NUTRITION</span></div>
          <div className="font-overline text-[10px] text-neutral-500 mt-1">PREMIUM SUPPLEMENT STORE</div>
          {user && (
            <div className="mt-4 flex items-center gap-3 p-3 bg-[#141414] border border-white/10">
              <div className="w-9 h-9 bg-[#D4AF37] text-black flex items-center justify-center font-bold uppercase">{user.name?.[0] || "U"}</div>
              <div className="min-w-0">
                <div className="text-sm font-bold truncate">{user.name}</div>
                <div className="text-[11px] text-neutral-500 truncate">{user.email}</div>
              </div>
            </div>
          )}
        </div>

        <div className="py-2">
          <div className="px-4 py-2 font-overline text-[9px] text-neutral-500">— NAVIGA</div>
          <Row to="/catalog" icon={LayoutGrid} label="Catalogo" onClick={close} testId="mobile-nav-catalog" />
          <Row to="/catalog" icon={ShoppingBag} label="Acquista Online" gold onClick={close} testId="mobile-nav-shop-online" />
          <Row to="/flyer" icon={Newspaper} label="Volantino" gold onClick={close} testId="mobile-nav-flyer" />
          <Row to="/blog" icon={BookOpen} label="Consigli & Guide" onClick={close} testId="mobile-nav-blog" />
          <Row to="/wheel" icon={Dice5} label="Ruota della Fortuna" gold onClick={close} testId="mobile-nav-wheel" />
          <Row to="/arcade" icon={Gamepad2} label="Arcade" gold onClick={close} testId="mobile-nav-arcade" />
          {isSilverOrGold && <Row to="/personal-shopper" icon={Crown} label="Personal Shopper" gold onClick={close} testId="mobile-nav-personal-shopper" />}

          {user && (
            <>
              <div className="px-4 py-2 mt-2 font-overline text-[9px] text-neutral-500">— ACCOUNT</div>
              <Row to="/profile" icon={User} label="Profilo & Punti" onClick={close} testId="mobile-nav-profile" />
              <Row to="/orders" icon={ShoppingBag} label="Ordini" onClick={close} testId="mobile-nav-orders" />
              {(user.role === "admin" || user.role === "staff") && <Row to="/admin" icon={Shield} label="Pannello Admin" gold onClick={close} testId="mobile-nav-admin" />}
            </>
          )}
        </div>

        <div className="px-4 py-4 space-y-2 border-t border-white/10">
          {user ? (
            <button onClick={() => { close(); onLogout(); }} className="w-full flex items-center justify-center gap-2 h-11 border border-white/15 text-neutral-300 hover:bg-white/5 font-overline text-[11px]" data-testid="mobile-logout">
              <LogOut className="w-4 h-4" /> Esci
            </button>
          ) : (
            <button onClick={() => { close(); navigate("/login"); }} className="w-full flex items-center justify-center gap-2 h-11 bg-[#D4AF37] hover:bg-[#E5C158] text-black font-overline text-[11px]" data-testid="mobile-login">
              <LogIn className="w-4 h-4" /> Accedi / Registrati
            </button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
